import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

interface Payload {
  email: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<null>('POST', `${APIV2_URL}/action/forgot-password`, { data });
